import HomePage from './pages/HomePage.svelte'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.svelte'
import CookiePolicyPage from './pages/CookiePolicyPage.svelte'
import TermsOfServicePage from './pages/TermsOfServicePage.svelte'
import ComingSoonPage from './pages/ComingSoonPage.svelte'
import CaseStudyPage from './pages/CaseStudyPage.svelte'
import PPEMarketPlace from './pages/PPEMarketPlace.svelte'

const routes = [
  {
    name: '/',
    component: HomePage
  },
  {
    name: 'privacy-policy',
    component: PrivacyPolicyPage
  },
  {
    name: 'cookie-policy',
    component: CookiePolicyPage
  },
  {
    name: 'terms-of-service',
    component: TermsOfServicePage
  },
  {
    name: 'case-studies-isans-marketplace',
    component: ComingSoonPage
  },
  {
    name: 'case-studies-banns-showcase-website',
    component: ComingSoonPage
  },
  {
    name: 'case-studies-ppe-marketplace',
    component: PPEMarketPlace
  },
  {
    name: 'about',
    component: ComingSoonPage,
  },
  {
    name: 'about-curbza-enterprise',
    component: ComingSoonPage,
  }
]

export { routes }